import axios from "redux/api";

export const fetchDataRegistries = async (page, limit, keyword) => {
  const response = await axios.get("/data-registry", {
    params: {
      offset: page * limit,
      limit,
      dataRegistryName: keyword,
      isPublic: true,
    },
  });
  return response.data;
};

export const fetchDataProjects = async (page, limit, keyword) => {
  const response = await axios.get("/project/get-projects-details", {
    params: {
      currentPage: page,
      pageSize: limit,
      keyword,
    },
  });
  return response.data.data;
};

export const fetchDatasets = async (projectId, page, limit, keyword) => {
  const response = await axios.post("/dataset/get-datasets-by-project", null, {
    params: {
      projectId,
      currentPage: page,
      pageSize: limit,
      keyword,
    },
  });
  return response.data.data;
};

export const fetchEvaluationReportProjects = async (page, limit, keyword) => {
  const response = await axios.get(
    "/labeling-evaluation-report/selectable-projects",
    {
      params: {
        currentPage: page,
        pageSize: limit,
        keyword,
      },
    },
  );
  return response.data.data;
};

export const fetchEvaluationReportDatasets = async (
  projectId,
  page,
  limit,
  keyword,
) => {
  const response = await axios.get(
    "/labeling-evaluation-report/selectable-datasets",
    {
      params: {
        projectId,
        currentPage: page,
        pageSize: limit,
        keyword,
      },
    },
  );
  return response.data.data;
};
